import React from 'react';

import Shield from '@/assets/icons/shield';
import { LOGO_HEIGHT_WIDTH } from '@/components/event-hud/EventHudDetails';
import { Box, Image } from '@/components/lib/components';
import { useResizeImage } from '@/components/player-profile/hooks/use-resize-image.web';

import './eventWidgetImage.css';

type Props = {
    primaryColor?: string;
    secondaryColor?: string;
    shouldShowFallbackLogo?: boolean;
    imageUrl?: string;
    width: number;
    height: number;
    shouldApplyMask?: boolean;
};

export const EventWidgetImageContainer = ({
    primaryColor,
    secondaryColor,
    shouldShowFallbackLogo,
    imageUrl,
    width,
    height,
    shouldApplyMask = false,
}: Props) => {
    const imageSource = useResizeImage({ source: imageUrl });

    return (
        <Box>
            {shouldApplyMask && imageSource ? (
                <div style={{ width, height }}>
                    <img src={imageSource} style={{ width, height }} className="eventImage" />
                </div>
            ) : shouldShowFallbackLogo ? (
                <Shield
                    primary={primaryColor}
                    secondary={secondaryColor}
                    width={LOGO_HEIGHT_WIDTH}
                    height={LOGO_HEIGHT_WIDTH}
                />
            ) : (
                <Image source={{ uri: imageUrl }} style={{ width: width, height: height }} resizeMode="contain" />
            )}
        </Box>
    );
};
